import { useContext } from "react";
import { motion } from "framer-motion";
import { dataContext } from "../../../context/context";
import './why.css';
import logo3d from "../../../assets/images/logo.png";

import sign0 from   "../../../assets/images/sign0.png";
import sign1 from   "../../../assets/images/sign1.png";
import sign2 from   "../../../assets/images/sign2.png";
import sign3 from   "../../../assets/images/sign3.png";





function Why() {

    const signs = [
        sign0,
        sign1,
        sign2,
        sign3
    ];

    const { data  } = useContext(dataContext);


    const section = data.sectionsdata.find(s => s.nick === 'why');
    const paragraphs = section ? section.paragraphsdata : [];

    if (paragraphs) {
        return (
            <section id="why">
                <h2><img src={logo3d} alt={section.title} />{section.title}</h2>
                <div className="transparent_block">


                    {
                        paragraphs.map((par, index) => (

                            <motion.div className="card" id={par.nick} key={index}
                                        initial={{ opacity: 0, y: 10, scale: 0.9 }}
                                        animate={{ opacity: 1, y: 0, scale: 1 }}
                                        transition={{ delay: index * 0.33, duration: 1 }}
                            >

                                    <h3>
                                        {signs[index] && (
                                            <img src={signs[index]} alt="" />
                                        )}

                                        {par.title}</h3>
                                    {par.text}


                            </motion.div>

                        ))
                    }

                </div>
                </section>
        ) } else return (<></>);




}

export default Why;